
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Lägg till på hemskärmen för att få en bättre användarupplevelse och enklare åtkomst.`,
's224cbcec014ef6b5': `Tryck på Dela-knappen i verktygsfältet`,
's37a9e8aec5713460': `Mer`,
's386eca8362ff6155': `Tryck på Mer om det inte finns någon delningsikon`,
's4e1e10a6ca408245': `Tryck på "Lägg till på hemskärmen"`,
's6196153c4b0c1ea0': `Installera`,
's633502f7cff4f847': `Öppna din webbläsares meny`,
's681e399d63311fba': `Visa galleri`,
's7f0591f08e318eda': `Tryck på Mer i delningsmenyn`,
's8114bd55cae5a22b': `Välj Lägg till i Dock`,
's922329d6f6213590': `Lägg till i Dock`,
's9af56bf005b49c74': `Scrolla ner till "Lägg till på hemskärmen"`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sba52286c21552a4e': `Installera den på din enhet för att få en bättre användarupplevelse och enklare åtkomst.`,
'sc16e00a7a8b2fde2': `Tillbaka`,
'scdaf4bbff76674c8': `Lägg till på hemskärmen`,
'se0e473adfda8066c': `Öppna i din huvudsakliga webbläsare`,
'se740f75b95a51807': `Lägg till i Dock för att få en bättre användarupplevelse och enklare åtkomst.`,
'sfea652f6580ff086': `Denna webbsajt har app-funktionalitet.`,
    };
  